import React, { useContext } from 'react';
import { useFelaEnhanced } from '@ackee/fela';
import { FormattedMessage } from 'react-intl';

import type { MessageKey } from 'modules/intl';

import { PixelatedBackgroundContext } from '../../PixelatedBackgroundWrapper';

import * as felaRules from './StatsContainer.rules';

const content = (['1', '2', '3', '4'] as const).map(id => ({
    title: `homepage.ourServices.stats.${id}.title`,
    value: `homepage.ourServices.stats.${id}.value`,
})) satisfies { title: MessageKey; value: MessageKey }[];

export const StatsContainer = () => {
    const backgroundMode = useContext(PixelatedBackgroundContext);
    const { styles } = useFelaEnhanced(felaRules, { backgroundMode });

    return (
        <div className={styles.container}>
            {content.map(({ title, value }) => (
                <div className={styles.stat} key={title}>
                    <span className={styles.statValue}>
                        <FormattedMessage id={value} />
                    </span>
                    <span className={styles.statName}>
                        <FormattedMessage id={title} />
                    </span>
                </div>
            ))}
        </div>
    );
};
